module.exports = __webpack_public_path__ + "img/walletBg.71f5d6d9.jpg";